import { render, staticRenderFns } from "./4_m_event.vue?vue&type=template&id=f10e6cc2&scoped=true&"
import script from "./4_m_event.vue?vue&type=script&lang=js&"
export * from "./4_m_event.vue?vue&type=script&lang=js&"
import style0 from "./4_m_event.vue?vue&type=style&index=0&id=f10e6cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10e6cc2",
  null
  
)

export default component.exports